import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import Accordion from "@material-ui/core/Accordion"
import AccordionDetails from "@material-ui/core/AccordionDetails"
import AccordionSummary from "@material-ui/core/AccordionSummary"
// import Typography from "@material-ui/core/Typography"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"

import DocumentContent from "./DocumentContent"

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(5),
  },
  heading: {
    color: theme.palette.primary.main,
    flexBasis: "300px",
    flexGrow: 0,
    flexShrink: 0,
    fontSize: "1rem",
    fontWeight: theme.typography.fontWeightMedium,
    margin: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    textTransform: "uppercase",
    whiteSpace: "nowrap",
  },
  secondaryHeading: {
    color: theme.palette.text.secondary,
    flexBasis: "200px",
    flexGrow: 0,
    flexShrink: 1,
    fontSize: theme.typography.pxToRem(15),
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  summaryContent: {
    maxWidth: "100%",
  },
  content: {
    display: "block",
  },
}))

export default function Accordions({ items, ...options }) {
  const classes = useStyles()
  const [expanded, setExpanded] = React.useState(false)

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  return (
    <div className={classes.root} {...options}>
      {items.map((item, index) => (
        <Accordion key={index} expanded={expanded === index} onChange={handleChange(index)}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`panel${index}-content`}
            id={`panel${index}-header`}
            classes={{
              content: classes.summaryContent,
            }}
          >
            <h3 className={classes.heading}>{item.title}</h3>
            {/* <Typography className={classes.secondaryHeading}>{item.content}</Typography> */}
          </AccordionSummary>
          <AccordionDetails id={`panel${index}-content`} className={classes.content}>
            <DocumentContent
              content={item.content}
              files={item.files && item.files.items ? item.files.items : []}
              title={item.title}
            />
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  )
}
